import { render, staticRenderFns } from "./overruleAddress.vue?vue&type=template&id=639578b9"
import script from "./overruleAddress.vue?vue&type=script&lang=js"
export * from "./overruleAddress.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports